import { transactionTypes, type TransactionType } from "./utils";

/**
 *
 */
export type SamplingEnvConfig = {
  [P in TransactionType]: { [pagecluster: string]: number[] | undefined };
};

/*                                  */
const pageLoadLive = {
  "AftersalesOrders": [1.00, 1.00, 1.00, 0.57, 0.30, 0.19, 0.12, 0.09, 0.09, 0.08, 0.08, 0.09, 0.09, 0.09, 0.09, 0.10, 0.10, 0.10, 0.10, 0.12, 0.16, 0.26, 0.46, 0.81],
  "AftersalesReturns": [1.00, 1.00, 1.00, 1.00, 1.00, 1.00, 0.60, 0.45, 0.45, 0.48, 0.48, 0.46, 0.46, 0.45, 0.44, 0.47, 0.47, 0.51, 0.63, 0.79, 1.00, 1.00, 1.00, 1],
  "Artikeldetailseite": [0.02, 0.03, 0.02, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.02],
  "BBS": [1.00, 1.00, 1.00, 1.00, 1.00, 1.00, 1.00, 0.79, 0.72, 0.61, 0.64, 0.62, 0.63, 0.64, 0.59, 0.60, 0.53, 0.48, 0.43, 0.46, 0.59, 1.00, 1.00, 1],
  "Checkout": [1.00, 1.00, 1.00, 1.00, 1.00, 0.74, 0.50, 0.37, 0.34, 0.29, 0.29, 0.28, 0.28, 0.29, 0.27, 0.28, 0.24, 0.22, 0.19, 0.21, 0.25, 0.39, 0.70, 1],
  "ConnectContact": [1.00, 1.00, 1.00, 1.00, 1.00, 1.00, 0.79, 0.57, 0.54, 0.47, 0.49, 0.51, 0.52, 0.52, 0.55, 0.63, 0.68, 0.78, 0.89, 1.00, 1.00, 1.00, 1.00, 1],
  "Einstiegsseite": [1.00, 1.00, 1.00, 1.00, 1.00, 0.68, 0.52, 0.44, 0.40, 0.35, 0.31, 0.16, 0.16, 0.19, 0.24, 0.35, 0.34, 0.29, 0.26, 0.27, 0.32, 0.50, 0.89, 1],
  "Kundenbewertungsseite": [1.00, 1.00, 1.00, 1.00, 1.00, 1.00, 0.62, 0.56, 0.51, 0.46, 0.47, 0.42, 0.46, 0.44, 0.43, 0.45, 0.40, 0.32, 0.27, 0.25, 0.33, 0.52, 1.00, 1],
  "Login": [1.00, 1.00, 1.00, 0.90, 0.45, 0.27, 0.17, 0.13, 0.12, 0.11, 0.12, 0.12, 0.12, 0.13, 0.12, 0.13, 0.12, 0.12, 0.11, 0.13, 0.18, 0.29, 0.55, 1],
  "MYA_Dashboard": [1.00, 1.00, 1.00, 0.55, 0.31, 0.21, 0.14, 0.10, 0.11, 0.09, 0.10, 0.10, 0.10, 0.10, 0.10, 0.11, 0.11, 0.10, 0.10, 0.12, 0.15, 0.24, 0.42, 0.71],
  "MYA_Invoices": [1.00, 1.00, 1.00, 0.62, 0.34, 0.24, 0.15, 0.12, 0.13, 0.11, 0.12, 0.12, 0.13, 0.13, 0.13, 0.15, 0.14, 0.13, 0.14, 0.17, 0.22, 0.35, 0.59, 1],
  "MYA_Orders": [1.00, 1.00, 0.85, 0.42, 0.23, 0.14, 0.10, 0.08, 0.07, 0.07, 0.07, 0.07, 0.07, 0.08, 0.07, 0.08, 0.08, 0.08, 0.08, 0.10, 0.13, 0.21, 0.39, 0.7],
  "Payment-Selection-FD-ViewPaymentSelection": [1.00, 1.00, 1.00, 1.00, 1.00, 1.00, 1.00, 1.00, 1.00, 1.00, 0.86, 0.82, 0.84, 0.86, 0.81, 0.86, 0.72, 0.66, 0.59, 0.63, 0.73, 1.00, 1.00, 1],
  "Paymentinfo": [1.00, 1.00, 1.00, 1.00, 0.49, 0.33, 0.21, 0.17, 0.17, 0.15, 0.17, 0.17, 0.17, 0.18, 0.18, 0.19, 0.18, 0.18, 0.19, 0.23, 0.31, 0.50, 0.82, 1],
  "Produktliste": [0.24, 0.34, 0.25, 0.19, 0.14, 0.11, 0.09, 0.08, 0.07, 0.06, 0.07, 0.06, 0.06, 0.06, 0.06, 0.06, 0.05, 0.04, 0.04, 0.04, 0.05, 0.07, 0.14, 0.23],
  "Storefront": [0.33, 0.37, 0.27, 0.19, 0.12, 0.09, 0.07, 0.06, 0.06, 0.04, 0.05, 0.05, 0.05, 0.05, 0.05, 0.05, 0.04, 0.04, 0.03, 0.04, 0.05, 0.08, 0.13, 0.23],
  "Suchergebnisseite": [0.13, 0.19, 0.18, 0.13, 0.08, 0.06, 0.04, 0.03, 0.03, 0.03, 0.03, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.01, 0.01, 0.02, 0.03, 0.05, 0.09],
  "Warenkorb": [0.49, 0.61, 0.64, 0.42, 0.26, 0.17, 0.12, 0.10, 0.09, 0.07, 0.08, 0.08, 0.08, 0.08, 0.07, 0.08, 0.07, 0.06, 0.05, 0.05, 0.06, 0.10, 0.19, 0.34],
  "Wishlist": [1.00, 1.00, 1.00, 0.74, 0.42, 0.29, 0.21, 0.17, 0.16, 0.13, 0.14, 0.13, 0.14, 0.13, 0.13, 0.13, 0.12, 0.10, 0.09, 0.09, 0.12, 0.19, 0.35, 0.64],
};

/**
 *
 *
 *
 */
const liveHttpRequest = {
  "Artikeldetailseite": [0.21, 0.28, 0.25, 0.20, 0.17, 0.25, 0.23, 0.21, 0.20, 0.24, 0.31, 0.30, 0.31, 0.31, 0.30, 0.33, 0.29, 0.25, 0.21, 0.20, 0.25, 0.35, 0.50, 0.7],
  "Produktliste": [0.20, 0.26, 0.28, 0.18, 0.13, 0.12, 0.07, 0.06, 0.05, 0.07, 0.09, 0.09, 0.13, 0.12, 0.12, 0.11, 0.08, 0.08, 0.09, 0.07, 0.09, 0.15, 0.25, 0.38],
  "Registration": [1.00, 1.00, 1.00, 1.00, 1.00, 1.00, 0.86, 0.79, 0.56, 0.66, 1.00, 0.87, 0.40, 0.38, 0.37, 0.34, 0.15, 0.15, 0.13, 0.13, 0.15, 0.23, 0.41, 0.58],
  "Suchergebnisseite": [0.15, 0.23, 0.24, 0.18, 0.12, 0.10, 0.06, 0.05, 0.04, 0.05, 0.07, 0.07, 0.10, 0.10, 0.09, 0.09, 0.08, 0.06, 0.05, 0.05, 0.07, 0.21, 0.22, 0.27],
}
/*                                 */

/**
 *
 *
 */
export const sampligRates: Record<"live" | "develop", SamplingEnvConfig> = {
  live: {
    [transactionTypes[0]]: pageLoadLive,
    [transactionTypes[1]]: liveHttpRequest,
  },
  develop: { [transactionTypes[0]]: {}, [transactionTypes[1]]: {} },
};

export const getSamplingRate = (
  type: TransactionType,
  pagecluster: string,
  now = new Date(),
  env = import.meta.env.VITE_OTTO_INSTALLATION_ENV,
): number => {
  const current = now.getUTCHours(); /*          */
  const rates = sampligRates[env];
  const rate = rates[type][pagecluster]?.[current] ?? 1;
  return rate;
};
